
import { Component, Vue, Watch } from "vue-property-decorator";
import { Loading, LavorazioniList, ProgressoOrdine, StatoWorkflow, LoadingTemplateType, CardEntityMetadata } from "@/components";
import { Lavorazione, StatoLavorazione, VariazioneLavorazione, Ordine, RequestSalvaDatiAggiuntiviOrdine, RequestAllegatoOrdineDownload, RequestSchedaTecnicaDownload } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';
import { truncate } from 'fs';
import saveAs from "file-saver";
import { log } from "console";

@Component({
    components: {
        Loading,
        LavorazioniList,
        ProgressoOrdine,
        StatoWorkflow,
        CardEntityMetadata
    }
})
export default class OrdineDettaglio extends Vue {

    private idLavorazioni: string[] = [];
    private mostraHeader = true;
    private dialog = false;
    public schedaTecnicaDialog = false;

    private inModificaNote = false;
    private valoreNoteTemp = '';

    modificaNote() {
        if (this.ordine) {
            this.valoreNoteTemp = this.ordine.note;
            this.inModificaNote = true;
        }
    }

    openSchedaTecnicaDialog() {
        this.schedaTecnicaDialog = true;
    }

    get isSchedaTecnicaDownloading() {
        return store.state.uiOrdine.isSchedaTecnicaDownloading;
    }

    get xlsxPackingListOrdineLoading() {
        return store.state.uiLavorazione.xlsxPackingListOrdineLoading;
    }

    public selectedModelloScheda: string = "";

    public async downloadSchedaTecnica() {
        let request: RequestSchedaTecnicaDownload = {
            modello: this.ordine?.modelloDecodificato.codiceParte ?? "",
            stagione: this.ordine?.stagioneDecodificata.id ?? "",
            templateScheda: this.selectedModelloScheda
        }

        let data = await store.dispatch(StoreActions.DownloadSchedaTecnica, request);
        if (data) {
            saveAs(data, `Scheda_Tecnica_${request.templateScheda}_${request.modello}_${request.stagione}.pdf`);
        }
    }

    public async downloadXLSXPackingListOrdine() {
        let data = await store.dispatch(StoreActions.DownloadXLSXPackingListOrdine, this.ordine?.id);
            if (data) {
                saveAs(data, `packing_list_ordine_${this.ordine?.id}.xlsx`);
            }
    }

    async inviaModificaNote() {
        if (this.ordine) {
            let ok = await store.dispatch(StoreActions.InviaModificaNoteOrdine, { idOrdine: this.ordine.id, note: this.valoreNoteTemp });

            if (ok) {
                this.inModificaNote = false;
            }
            else {
                store.commit(StoreMutations.SetMessaggiErrore, ["Errore durante il tentativo di modifica delle note dell'ordine."]);
            }
        }
    }

    get ordine(): Ordine | undefined {
        return store.state.ordineCorrente;
    }

    get listaModelliSchede(): string[] {
        return store.state.datiLookup?.modelliSchedeTecniche ?? [];
    }
    get listaModelliCorrentiSchede(): string[] {
        return store.state.modelliSchedeCorrenti ?? [];
    }

    // get listaModelliMancanti() : string[]{
    //     return this.listaModelliSchede.filter(m => !this.listaModelliCorrentiSchede.includes(m));
    // }

    get iconClassByProgress(): string {

        if (this.ordine && this.ordine.progresso == 0) {
            return 'grey';
        }
        else if (this.ordine && this.ordine.progresso == 100) {
            return 'green';
        }

        return 'amber';
    }

    get statoLavorazioniAllineato(): boolean {
        if (this.ordine && this.ordine.lavorazioni && this.ordine.lavorazioni.length > 0) {
            let stato = this.ordine.lavorazioni[0].stato;
            let statiDiversi = this.ordine.lavorazioni.some(l => l.stato != stato);
            return !statiDiversi;
        }
        return false;
    }

    get progressiGestibili(): boolean {
        let result = false;
        if (store.state.ordineCorrente && store.state.ordineCorrente.progresso < 100) {
            store.state.ordineCorrente.lavorazioni.some(lav => {
                result = lav.stato == StatoLavorazione.IN_CORSO_DI_LAVORAZIONE && lav.progresso < 100;
                return result;
            });
        }

        return result;
    }

    get azioniDisponibili(): boolean {
        return store.state.azioniLavorazioni.some(azLav => azLav.azioni.some(a => a != 'AGGIORNA_LAVORAZIONE'));
        //return store.state.azioniLavorazioni && store.state.azioniLavorazioni.some(azLav => azLav.azioni.some(a => a != 'AGGIORNA_LAVORAZIONE'));
    }

    get loadTemplateCorrente(): LoadingTemplateType {
        return LoadingTemplateType.OrdineDettaglio
    }

    menuAzioni() {
        store.commit(StoreMutations.SetOpzioniVisibili, true);
    }

    @Watch("$route.params.id", { immediate: true })
    async onIdChanged(newId: string, oldId: string) {
        if (oldId) {
            this.beforeDestroy();
        }
        store.commit(StoreMutations.SetSottotitoloPagina, newId);
        await store.dispatch(StoreActions.GetOrdine, newId);
        if (this.ordine) {
            this.idLavorazioni = this.ordine.lavorazioni.map(lav => lav.id);
            //store.dispatch(StoreActions.WatchLavorazioni, this.idLavorazioni);
            store.dispatch(StoreActions.GetModelliSchedeDaModelloEStagione, { modello: this.ordine.modello, stagione: this.ordine.stagione_Codice });
            store.dispatch(StoreActions.WatchNotificheGruppi);
            store.dispatch(StoreActions.GetAzioniPossibiliPerLavorazioni, this.idLavorazioni);
            store.dispatch(StoreActions.OperazioniEtichetteDremeDisponibiliPerOrdine, newId);
            store.dispatch(StoreActions.GetResetEPCDisponibile);
            store.dispatch(StoreActions.GetStampaEtichetteRfidDisponibile);
            store.dispatch(StoreActions.GetStampaEtichetteNoRfidDisponibile);
        }
    }

    get loading() {
        return !store.state.ui.opzioniVisibili && store.state.loading && !this.dialog;
    }

    private buttonDownloadIsLoading() {
        return store.state.uiOrdini.downloadButtonLoading;
    }

    private beforeDestroy() {
        //store.dispatch(StoreActions.UnwatchLavorazioni, this.idLavorazioni);
        store.dispatch(StoreActions.UnwatchNotificheGruppi);
    }

    async editProgressi() {
        if (this.ordine && this.progressiGestibili) {
            // load lavorazioni
            let ids = this.ordine.lavorazioni
                .filter(lav => lav.stato == StatoLavorazione.IN_CORSO_DI_LAVORAZIONE && lav.progresso < 100)
                .map(lav => lav.id);

            await store.dispatch(StoreActions.GetLavorazioni, ids);

            this.dialog = true;
        }
    }

    private async saveDatiAggiuntivi() {
        const request: RequestSalvaDatiAggiuntiviOrdine = {
            idOrdine: this.ordine?.id,
            datiAggiuntivi: this.ordine?.datiAggiuntivi
        }
        await store.dispatch(StoreActions.SalvaDatiAggiuntiviOrdine, request);
    }

    private async downloadAllegato(lam: string) {

        let request: RequestAllegatoOrdineDownload = {
            lam: lam,
        }

        let data = await store.dispatch(StoreActions.DownloadAllegatoOrdine, request);
        if (data) {
            saveAs(data, `Ordine_Produzione_${lam}.pdf`);
        }
    }

    private showPackingList() {
        this.$router.push({ name: 'oaf', params: { id: this.ordine?.id ?? ""}});
    }

    // STAMPA ETICHETTE
    stampaEtichettePerOrdine(operazione: string) {
        store.dispatch(StoreActions.StampaEtichettePerOrdine, { operazione: operazione, idOrdine: store.state.ordineCorrente?.id });
    }

    get canResetEPC(): boolean {
        return store.state.uiOrdine.stampaEtichette.resetEpcDisponibile;
    }

    get canPrintEtichette(): boolean {
        return store.state.uiOrdine.stampaEtichette.stampaDisponibile;
    }

    get stampaEtichetteRfidDisponibile() : boolean {
        return store.state.stampaEtichetteRfidDisponibile;
    }

    get stampaEtichetteNoRfidDisponibile() : boolean {
        return store.state.stampaEtichetteNoRfidDisponibile;
    }

}
